import { Store } from './rootReducer';

export type Nullable<T> = T | null;

//Types
export enum ACTIONS {
  'OPEN_SIGN_IN' = 'OPEN_SIGN_IN',
  'OPEN_SIGN_UP' = 'OPEN_SIGN_UP',
  'ACCESSIBILITY_STATEMENT_CONTENT' = 'ACCESSIBILITY_STATEMENT_CONTENT',
  'ACCESSIBILITY_STATEMENT_PROJECT_ID' = 'ACCESSIBILITY_STATEMENT_PROJECT_ID',
  'PRIVACY_POLICY_CONTENT' = 'PRIVACY_POLICY_CONTENT',
  'CLOSE_FORM' = 'CLOSE_FORM',
  'LANDING_PAGE_INTRO_TEXT' = 'LANDING_PAGE_INTRO_TEXT',
}

// State
export type OpenFormState = {
  landingPageForm: string | null;
  redirectURL: string | null;
  accessibilityStatement: string | null;
  accessibilityStatementProjectId: number | null;
  privacyPolicy: string | null;
  introText: string | null;
};

export const initialState: OpenFormState = {
  landingPageForm: null,
  redirectURL: null,
  accessibilityStatement: null,
  accessibilityStatementProjectId: null,
  privacyPolicy: null,
  introText: null,
};

// Actions
export type Action =
  | {
      type: ACTIONS.OPEN_SIGN_IN;
    }
  | {
      type: ACTIONS.OPEN_SIGN_UP;
      payload: string | null;
    }
  | {
      type: ACTIONS.ACCESSIBILITY_STATEMENT_CONTENT;
      payload: string | null;
    }
  | {
      type: ACTIONS.ACCESSIBILITY_STATEMENT_PROJECT_ID;
      payload: number | null;
    }    
  | {
    type: ACTIONS.PRIVACY_POLICY_CONTENT;
    payload: string | null;
    }
  | {
    type: ACTIONS.LANDING_PAGE_INTRO_TEXT;
    payload: string | null;
    }    
  | {
    type: ACTIONS.CLOSE_FORM;
    };

// Reducer
export default function modalReducer(
  state = initialState,
  action: Action
): OpenFormState {
  switch (action.type) {
    case ACTIONS.OPEN_SIGN_IN:
      return {
        ...state,
        landingPageForm: 'SIGN_IN',
      };
    case ACTIONS.OPEN_SIGN_UP:
      return {
        ...state,
        landingPageForm: 'SIGN_UP',
        redirectURL: action.payload,
      };
    case ACTIONS.ACCESSIBILITY_STATEMENT_CONTENT:
      return {
        ...state,
        accessibilityStatement: action.payload,
      };
    case ACTIONS.ACCESSIBILITY_STATEMENT_PROJECT_ID:
      return {
        ...state,
        accessibilityStatementProjectId: action.payload,
      };      
    case ACTIONS.PRIVACY_POLICY_CONTENT:
      return {
        ...state,
        privacyPolicy: action.payload,
      };   
    case ACTIONS.LANDING_PAGE_INTRO_TEXT:
      return {
        ...state,
        introText: action.payload,
      };                   
    case ACTIONS.CLOSE_FORM:
      return {
        ...state,
        landingPageForm: null,
        redirectURL: null,
      };

    default:
      return state;
  }
}

// Action creators
export const setOpenSignInForm = () => ({
  type: ACTIONS.OPEN_SIGN_IN,
});
export const setOpenSignUpForm = (payload?: string) => ({
  type: ACTIONS.OPEN_SIGN_UP,
  payload,
});
export const setCloseLandingPageForm = () => ({
  type: ACTIONS.CLOSE_FORM,
});
export const setAccessibilityStatement = (payload?: string) => ({
  type: ACTIONS.ACCESSIBILITY_STATEMENT_CONTENT,
  payload,
});
export const setAccessibilityStatementProjectId = (payload?: number) => ({
  type: ACTIONS.ACCESSIBILITY_STATEMENT_PROJECT_ID,
  payload,
});
export const setPrivacyPolicy = (payload?: string) => ({
  type: ACTIONS.PRIVACY_POLICY_CONTENT,
  payload,
});
export const setLandingPageIntroText = (payload?: string) => ({
  type: ACTIONS.LANDING_PAGE_INTRO_TEXT,
  payload,
});
// Selectors
export const selectSignInFormState = (state: Store) =>
  state.landingPage.landingPageForm;
export const selectSignInRedirectURL = (state: Store) =>
  state.landingPage.redirectURL;
export const selectAccessibilityStatement = (state: Store) =>
  state.landingPage.accessibilityStatement;
export const selectAccessibilityStatementProjectId = (state: Store) =>
  state.landingPage.accessibilityStatementProjectId;
export const selectPrivacyPolicy = (state: Store) =>
  state.landingPage.privacyPolicy;
export const selectLandingPageIntroText = (state: Store) =>
  state.landingPage.introText;
